export const module = {
  info: {
    name: 'voip-destination-side-menu',
    caption: 'voip destination side menu',
    viewGroup: 'fasfreeroute-modules'
  },
  vuexModules: [],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Destinations',
    icon: 'el-icon-top-right',
    routeName: 'module->voip-destination->list->page',
    routeParams: { listPage: 1},
    children: [
      {
        caption: 'Add Working Destination',
        icon: 'el-icon-plus',
        routeName: 'module->voip-destination->add-working-destination'
      },
      {
        caption: 'Reset Destination',
        icon: 'el-icon-refresh',
        routeName: 'module->voip-destination->reset-destination'
      },
      {
        caption: 'List',
        icon: 'el-icon-top-right',
        routeName: 'module->voip-destination->list->page',
        routeParams: { listPage: 1}
      }
    ]
  }
}

export default module
